export enum ProductType {
  Hotel = 'hotel',
  Flight = 'flight',
  Vehicle = 'auto',
}
